define('presentation/welcome/facades/onboardingIdentityFacade',[
    'businessServices/onboarding/liveReceptionistOnboardingSingleton',
    'common/promises/promiseFactory',
], function() {

    const _liveReceptionistOnboardingState = require('businessServices/onboarding/liveReceptionistOnboardingSingleton');

    let _promiseFactory = null;

    const _getLiveReceptionistOnboarding = () => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.getLiveReceptionistOnboarding()
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveAgentTone = (agentTone) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveAgentTone(parseInt(agentTone))
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveAccountBusinessName = (accountBusinessName) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveAccountBusinessName(accountBusinessName)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveBusinessDescription = (description) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveBusinessDescription(description)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveBusinessName = (businessName) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveBusinessName(businessName)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveIndustry = (industry) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveIndustry(industry)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveMayForwardFromNumbers = (mayForwardFromNumbers) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveMayForwardFromNumbers(mayForwardFromNumbers)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveNumberOfEmployees = (numberOfEmployees) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveNumberOfEmployees(numberOfEmployees)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveNumberIntentSelection = (numberIntentSelection) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveNumberIntentSelection(parseInt(numberIntentSelection))
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };


    const _saveOnboardingStatus = (onboardingStatus) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveOnboardingStatus(onboardingStatus)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    return function() {
        let self = this;
        self.init = _init;

        self.getLiveReceptionistOnboarding = _getLiveReceptionistOnboarding;
        self.saveAccountBusinessName = _saveAccountBusinessName;
        self.saveAgentTone = _saveAgentTone;
        self.saveBusinessDescription = _saveBusinessDescription;
        self.saveBusinessName = _saveBusinessName;
        self.saveIndustry = _saveIndustry;
        self.saveMayForwardFromNumbers = _saveMayForwardFromNumbers;
        self.saveNumberOfEmployees = _saveNumberOfEmployees;
        self.saveNumberIntentSelection = _saveNumberIntentSelection;
        self.saveOnboardingStatus = _saveOnboardingStatus;
    };
});

